<template>
    <div class="lg:grid lg:grid-cols-12 bg-blue-50">
        <div class="px-6 py-4 lg:col-span-3">
            <div class="text-gray-900 text-2xl mb-1 font-mono font-medium">{{ outturn.out_turn_number  }}</div>
            <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Outturn Number</div>
        </div>
        <div class="px-6 py-4 lg:col-span-3">
            <div class="text-gray-900 text-2xl mb-1 font-mono font-medium">{{ outturn.print_check_code  }}</div>
            <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Date</div>
        </div>
        <div class="px-6 py-4 lg:col-span-3">
            <div class="flex outturns-center text-gray-900 text-2xl mb-1 font-mono font-medium">
                <span>{{ outturn.recap_number  }}</span>
                <outturn-recap :outturn="outturn" />
            </div>
            <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Recap Number</div>
        </div>
        <div class="px-6 py-4 lg:col-span-3">
            <a :href="`/outturn-listings/${outturn.id}/download`" target="_blank" class="flex items-center text-blue-600 cursor-pointer">
                <svg class="w-6 h-6 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"></path></svg>
                <span class="font-semibold">Print / Export</span>
            </a>
        </div>
    </div>
</template>

<script>
import OutturnRecap from "@/Components/Outturn/OutturnRecap";

export default {
    components: { OutturnRecap },
    props: {
        outturn: {
            type: Object,
            required: true,
            defualt: {}
        }
    },
}
</script>
